import { useState } from "react";
import { faMaximize } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatClassTime } from "../utils/classTimeUtils";
import { formatDisplayDate } from "../utils/dateFormat";
import TeacherPhoto from "./TeacherPhoto";

function AllCoursesViewer({
  courses,
  mycourses,
  filterKey,
  selectCourse,
  selectedCourseIds,
  isLogin,
  loginWithPopup,
}) {
  const [selectedcourse, setselectedcourse] = useState(null);
  const [showdetails, setshowdetails] = useState(false);
  const [selectedcourseregistered, setselectedcourseregistered] =
    useState(false);
  return (
    <div className="row">
      {courses
        .filter((course) =>
          course.title?.toLowerCase().includes(filterKey.toLowerCase())
        )
        .map((course) => {
          const registeredCourseIds = mycourses?.flatMap((myCourse) =>
            myCourse.courses
              .filter(
                (c) =>
                  c.status === "pending" ||
                  c.status === "enrolled"
              )
              .map((c) => c.courseId)
          );

          const isRegistered = registeredCourseIds?.includes(course.id);

          return (
            <div key={course.id} className="col-md-6">
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "15px",
                  padding: "20px",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#F5F5F7",
                  marginBottom: "30px",
                }}
                className="row"
              >
                <div className="col-md-6">
                  <TeacherPhoto
                    picture={course.Teacher?.picture}
                    name={course.Teacher?.name}
                    variant="portrait"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "15px",
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <h6>{filterKey.toUpperCase()}</h6>
                  <h3>{course.title.toUpperCase()}</h3>
                  <h6
                    style={{
                      backgroundColor: "#bff1db",
                      padding: "5px 10px",
                      borderRadius: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {course.Teacher?.name.toUpperCase()}
                  </h6>

                  <p
                    style={{
                      backgroundColor: "#f9e1be",
                      padding: "5px 10px",
                      borderRadius: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {course.id}
                  </p>
                  <p
                    style={{
                      backgroundColor: "#f2c4c4",
                      padding: "5px 10px",
                      borderRadius: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {formatClassTime(course.classTime)}
                  </p>
                  {/* <p style={{ color: "#555" }}>Start Date: {startDate}</p>
                  <p style={{ color: "#555" }}>
                    Fee: {course.fee || "Unknown"}
                  </p>
                  <p style={{ color: "#555" }}>
                    Duration: {course.duration || "Unknown"}
                  </p> */}
                  <div className="d-flex justify-content-between align-items-center">
                    {isRegistered ? (
                      <h5 style={{ color: "#d5d1fd" }}>Registered</h5>
                    ) : (
                      <>
                        <button
                          className="btn btn-primary"
                          onClick={
                            isLogin ? selectCourse(course) : loginWithPopup
                          }
                          style={{
                            backgroundColor: selectedCourseIds.includes(
                              course.id
                            )
                              ? "#d5d1fd" // different shade for selected
                              : "#d5d1fd",
                            borderColor: "#d5d1fd",
                            padding: "10px 20px",
                          }}
                        >
                          {isLogin
                            ? selectedCourseIds.includes(course.id)
                              ? "Remove"
                              : "Add to Cart"
                            : "Register"}
                        </button>
                      </>
                    )}
                    <FontAwesomeIcon
                      icon={faMaximize}
                      style={{
                        fontSize: "30px",
                        color: "#d5d2fd",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setselectedcourse(course);
                        setselectedcourseregistered(isRegistered);
                        setshowdetails(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      {showdetails && (
        <div
          className="modal show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }} // Added background color
          tabIndex="-1"
        >
          <div
            className="modal-dialog"
            style={{
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="modal-content"
              style={{
                flexGrow: 1,
                backgroundColor: "#ffffff",
                borderRadius: "15px",
              }}
            >
              <div
                className="modal-body"
                style={{
                  overflowY: "auto",
                  maxHeight: "80vh",
                }}
              >
                <div className="row mb-4">
                  <button
                    type="button"
                    className="btn-close"
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                    }}
                    onClick={() => {
                      setshowdetails(false);
                    }}
                    aria-label="Close"
                  ></button>
                  <div className="col-md-12 text-center mt-4">
                    <h3
                      style={{
                        padding: "5px 10px",
                        marginBottom: "30px",
                      }}
                    >
                      {selectedcourse.title.toUpperCase()}
                    </h3>
                    <p
                      style={{
                        padding: "5px 10px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>Course ID: </strong>
                      {selectedcourse.id}
                    </p>
                    <p
                      style={{
                        padding: "5px 10px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>Teacher: </strong>
                      {selectedcourse.Teacher?.name}
                    </p>
                    <p
                      style={{
                        padding: "5px 10px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>Class Time: </strong>
                      {formatClassTime(selectedcourse.classTime)}
                    </p>
                    <p
                      style={{
                        padding: "5px 10px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>Start Date: </strong>
                      {formatDisplayDate(selectedcourse.startDate, "N/A")}
                    </p>
                    <p
                      style={{
                        padding: "5px 10px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>Duration: </strong>
                      {selectedcourse.duration}
                    </p>
                    <p
                      style={{
                        padding: "5px 10px",
                        marginBottom: "30px",
                      }}
                    >
                      <strong>Fee: </strong>
                      PKR {selectedcourse.fee + ' '}/month
                    </p>
                    {selectedcourseregistered ? (
                      <h5 style={{ color: "#d5d1fd" }}>Registered</h5>
                    ) : (
                      <>
                        <button
                          className="btn btn-primary"
                          onClick={selectCourse(selectedcourse)}
                          style={{
                            backgroundColor: selectedCourseIds.includes(
                              selectedcourse.id
                            )
                              ? "#d5d1fd" // different shade for selected
                              : "#d5d1fd",
                            borderColor: "#d5d1fd",
                            padding: "10px 20px",
                          }}
                        >
                          {selectedCourseIds.includes(selectedcourse.id)
                            ? "Remove"
                            : "Select"}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AllCoursesViewer;
